module.exports = __webpack_public_path__ + "dfefa273f01ddbd6341785f8d1d6a5e7.svg";